import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center">
                <span className="text-background-50 font-bold text-lg font-heading">90</span>
              </div>
              <span className="text-xl font-bold text-foreground-50 font-heading">90影视</span>
            </Link>
            <p className="text-foreground-500 text-sm leading-relaxed">
              免费在线观看平台，电影电视剧综艺动漫全集不缓冲无广告，高清画质流畅播放，最新热剧每日更新。
            </p>
          </div>

          <div>
            <h4 className="text-foreground-200 font-semibold mb-4 text-sm">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-200 font-semibold mb-4 text-sm">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-foreground-500 hover:text-primary-400 text-sm transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-200 font-semibold mb-4 text-sm">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-foreground-500">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@90yingshi.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-primary-400"></i>
                <span>90yingshi_official</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-400"></i>
                <span>每日 9:00 - 21:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-600 text-xs">
            &copy; {new Date().getFullYear()} 90影视 - 版权所有 | 本站所有内容均来自互联网，仅供学习交流使用
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-600 hover:text-foreground-300 text-xs transition-colors" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-foreground-600 hover:text-foreground-300 text-xs transition-colors" rel="nofollow">
              服务条款
            </a>
            <a href="#" className="text-foreground-600 hover:text-foreground-300 text-xs transition-colors" rel="nofollow">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}